export class InvalidCourseNameError extends Error {}

const isValidId = (n: number) => Number.isFinite(n) && n >= 0;

export default function getCourseAndFirmFromFile(file: string) {
  if (!file.includes('_')) {
    const courseId = +file;

    if (!isValidId(courseId))
      throw new InvalidCourseNameError(`Invalid course name: ${file}`);

    return { courseId };
  } else {
    const m = file.match(/(?:(\w+))_(\d+)/);
    const [, firmCode, courseIdStr] = m || [];
    const courseId = +courseIdStr;

    if (!firmCode || !isValidId(courseId))
      throw new InvalidCourseNameError(`Invalid course name: ${file}`);

    return { courseId, firmCode };
  }
}
